// Resources
import { provinceOptions } from "Constants/ProvinceConstants";

export const getDemographicsFields = (t) => [
  {
    id: "firstName",
    label: t("patientForm.firstNameLabel"),
    type: "text",
    autoComplete: "name",
    slotProps: { htmlInput: { maxLength: 30 } },
  },
  {
    id: "lastName",
    label: t("patientForm.lastNameLabel"),
    type: "text",
    slotProps: { htmlInput: { maxLength: 75 } },
  },
  {
    id: "dob",
    label: t("patientForm.dobLabel"),
    type: "date",
  },
  {
    id: "address",
    label: t("patientForm.addressLabel"),
    type: "text",
    slotProps: { htmlInput: { maxLength: 75 } },
  },
  {
    id: "city",
    label: t("patientForm.cityLabel"),
    type: "text",
    sx: { flex: 1 },
    slotProps: { htmlInput: { maxLength: 30 } },
  },
  {
    id: "province",
    label: t("patientForm.provinceLabel"),
    type: "select",
    sx: { flex: 1 },
    options: provinceOptions,
  },
  {
    id: "postalCode",
    label: t("patientForm.postalCodeLabel"),
    type: "text",
  },
];

export const getHealthCardFields = (t) => [
  {
    id: "healthCardNumber",
    label: t("patientForm.healthCardNumberLabel"),
    type: "text",
    sx: { width: "100%" },
  },
  {
    id: "registrationNumber",
    label: t("patientForm.registrationNumberLabel"),
    type: "text",
    sx: { flex: 1 },
  },
  {
    id: "healthCardProvince",
    label: t("patientForm.healthCardProvinceLabel"),
    type: "select",
    sx: { flex: 1 },
    options: provinceOptions,
  },
];

export const getContactFields = (t) => [
  {
    id: "email",
    label: t("patientForm.emailLabel"),
    type: "email",
    autoComplete: "email",
    slotProps: { htmlInput: { maxLength: 75 } },
  },
  {
    id: "primaryPhone",
    label: t("patientForm.phoneNumberLabel"),
    type: "tel",
    required: false,
    sx: { flex: 1 },
    slotProps: { htmlInput: { maxLength: 14 } },
  },
  {
    id: "secondaryPhone",
    label: t("patientForm.secondaryPhoneNumberLabel"),
    type: "tel",
    required: false,
    sx: { flex: 1 },
    slotProps: { htmlInput: { maxLength: 14 } },
  },
  {
    id: "preferredLanguage",
    label: t("patientForm.preferredLanguageLabel"),
    type: "select",
    options: [
      { value: "en", label: t("languages.english") },
      { value: "fr", label: t("languages.french") },
    ],
  },
];

export const getAccountDetailsFields = (t) => [
  {
    id: "userEmail",
    label: t("patientForm.userEmailLabel"),
    type: "email",
    autoComplete: "email",
    disabled: true,
  },
  {
    id: "updatedAt",
    label: t("patientForm.updatedAtLabel"),
    type: "date",
    required: false,
    disabled: true,
  },
];

// Validation required fields for patients in the system vs guest patients

export const guestRequiredFields = new Set([
  "firstName",
  "lastName",
  "dob",
  "healthCardProvince",
  "healthCardNumber",
  "preferredLanguage",
]);

export const inSystemRequiredFields = new Set([
  ...guestRequiredFields,
  "address",
  "city",
  "province",
  "postalCode",
  "email",
]);
